import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode } from 'react';

interface Props {
  stepKey: string;
  direction: 1 | -1;
  children: ReactNode;
}

/**
 * Transición reutilizable para wizards de pasos: el contenido entra
 * deslizándose desde la derecha al avanzar y desde la izquierda al
 * retroceder. El wrapper externo anima también el alto (`layout`) para que
 * el cambio de tamaño entre pasos de distinto contenido no "salte" de golpe.
 */
const AnimatedStepPanel = ({ stepKey, direction, children }: Props) => {
  return (
    <motion.div layout className="relative overflow-x-hidden">
      <AnimatePresence exitBeforeEnter initial={false}>
        <motion.div
          key={stepKey}
          initial={{ opacity: 0, x: direction > 0 ? 48 : -48 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: direction > 0 ? -48 : 48 }}
          transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
          className="p-1"
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
};

export default AnimatedStepPanel;
